import type { LinkType } from '../types';

type HookReturnType = ModelHookResult<{
	href: string;
	linkTextTranslationKey: string;
}>;

function getLinkTextKey(linkType?: LinkType): string {
	if (!linkType) {
		return 'link_text';
	}

	return 'all_activity_link_text';
}

export function usePetitionActivityLink({ slug, linkType }: { slug: string; linkType?: LinkType }): HookReturnType {
	const linkTextTranslationKey = getLinkTextKey(linkType);

	return {
		data: {
			linkTextTranslationKey,
			href: `/p/${encodeURIComponent(slug)}/activity/${linkType ?? ''}`,
		},
	};
}
